export const fonts = {
    normal: 'DINPro',
    condensed: 'DINPro Condensed',
};
